"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nounsDelegatedVotes = void 0;
const NounsABI_json_1 = __importDefault(require("../abi/NounsABI.json"));
const parseBlockTag_1 = require("../utils/parseBlockTag");
const ethers_1 = require("ethers");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
/**
 * Calculates number of delegate votes for NounsDAO
 */
const nounsDelegatedVotes = (params) => {
    return async () => {
        const { account, blockTag, provider, multiplier } = params;
        const _contract = new ethers_1.Contract('0x9C8fF314C9Bc7F6e59A9d9225Fb22946427eDC03', NounsABI_json_1.default, provider);
        const balance = await _contract.getCurrentVotes(account, {
            blockTag: (0, parseBlockTag_1.parseBlockTag)(blockTag),
        });
        const parsedBal = new bignumber_js_1.default(balance.toString()).toNumber();
        return parsedBal * multiplier;
    };
};
exports.nounsDelegatedVotes = nounsDelegatedVotes;
